import { Link, useNavigate } from "react-router-dom";
import { Minus, Plus, Trash2, ShoppingBag, Image as ImgIcon, ChevronLeft } from "lucide-react";
import { useCart } from "../lib/cart";
import { money } from "../lib/api";

export default function CartPage() {
  const { items, update, remove, subtotal } = useCart();
  const nav = useNavigate();

  if (items.length === 0) {
    return (
      <div className="min-h-screen bg-[#0A0908] text-[#F5F0E6] flex items-center justify-center">
        <div className="text-center" data-testid="cart-empty">
          <ShoppingBag size={48} className="mx-auto text-[#C89B3C] mb-4" />
          <h2 className="text-3xl mb-2" style={{ fontFamily: "'Playfair Display'" }}>Tu carrito está vacío</h2>
          <p className="text-[#F5F0E6]/60 mb-6">Explora nuestra colección western.</p>
          <Link to="/shop" className="inline-block bg-[#C89B3C] hover:bg-[#E6BF5F] text-[#0A0908] font-bold uppercase tracking-wider px-6 py-3 rounded-full">
            Ir a la tienda
          </Link>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-[#0A0908] text-[#F5F0E6]">
      <div className="max-w-6xl mx-auto px-4 md:px-8 py-10">
        <Link to="/shop" className="inline-flex items-center gap-1 text-sm text-[#F5F0E6]/60 hover:text-[#C89B3C] mb-4">
          <ChevronLeft size={16} /> Seguir comprando
        </Link>
        <h1 className="text-4xl md:text-5xl mb-8" style={{ fontFamily: "'Playfair Display'", fontWeight: 700 }}>Tu Carrito</h1>

        <div className="grid lg:grid-cols-[1fr_360px] gap-8">
          <ul className="space-y-4" data-testid="cart-items">
            {items.map((it) => (
              <li key={`${it.product_id}-${it.variant_id || "x"}`} className="flex gap-4 p-4 bg-[#120F0D] border border-white/5 rounded-xl" data-testid={`cart-item-${it.product_id}`}>
                <div className="w-20 h-24 bg-black/40 rounded-lg overflow-hidden shrink-0">
                  {it.image ? <img src={it.image} alt="" className="w-full h-full object-cover" /> : <div className="w-full h-full flex items-center justify-center text-white/20"><ImgIcon size={28} /></div>}
                </div>
                <div className="flex-1 min-w-0">
                  <h3 className="font-semibold" style={{ fontFamily: "'Playfair Display'" }}>{it.name}</h3>
                  <p className="text-xs text-[#F5F0E6]/60 mt-1">
                    {it.size && <>Talla {it.size}</>}
                    {it.size && it.color && " · "}
                    {it.color && <>{it.color}</>}
                  </p>
                  <div className="flex items-center justify-between mt-3">
                    <div className="inline-flex items-center border border-white/15 rounded-full text-sm">
                      <button onClick={() => update(it.product_id, it.variant_id, it.quantity - 1)} className="p-1.5" data-testid={`cart-dec-${it.product_id}`}><Minus size={12} /></button>
                      <span className="w-7 text-center">{it.quantity}</span>
                      <button onClick={() => update(it.product_id, it.variant_id, it.quantity + 1)} className="p-1.5" data-testid={`cart-inc-${it.product_id}`}><Plus size={12} /></button>
                    </div>
                    <p className="font-bold">{money(it.price * it.quantity)}</p>
                  </div>
                </div>
                <button onClick={() => remove(it.product_id, it.variant_id)} className="self-start p-2 text-[#F5F0E6]/40 hover:text-red-400" data-testid={`cart-remove-${it.product_id}`}>
                  <Trash2 size={16} />
                </button>
              </li>
            ))}
          </ul>

          <aside className="bg-[#120F0D] border border-white/10 rounded-xl p-6 h-fit sticky top-24">
            <h2 className="text-xl mb-4" style={{ fontFamily: "'Playfair Display'" }}>Resumen</h2>
            <div className="space-y-2 text-sm">
              <div className="flex justify-between"><span className="text-[#F5F0E6]/70">Subtotal</span><span data-testid="cart-subtotal">{money(subtotal)}</span></div>
              <div className="flex justify-between text-[#F5F0E6]/60"><span>Envío</span><span>Se calcula en checkout</span></div>
            </div>
            <div className="border-t border-white/10 my-4" />
            <div className="flex justify-between text-lg font-bold mb-5">
              <span>Total estimado</span><span>{money(subtotal)}</span>
            </div>
            <button onClick={() => nav("/shop/checkout")} className="w-full bg-[#C89B3C] hover:bg-[#E6BF5F] text-[#0A0908] font-bold uppercase tracking-wider py-3 rounded-full" data-testid="cart-checkout-btn">
              Ir a Pagar
            </button>
          </aside>
        </div>
      </div>
    </div>
  );
}
